import * as angular from "angular";
import {IController} from "angular";

export class PlanningProjectsViewCtrl implements IController {


  public currentNavItem: any;

  /* @ngInject */
  constructor(private $state) {
  }

  $onInit() {
    this.currentNavItem = undefined;
    this.currentNavItem = this.$state.current.url;
  }

}


angular
  .module('bringoz.admin.planning')
  .component('planningProjectsView', {
    template: require('./planning-projects-view.html').default,
    controller: PlanningProjectsViewCtrl
  });
